import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import Reveal from "@/components/anim/Reveal";

const ServicesGrid = ({ compact = false }) => {
  const { t } = useLang();
  const items = t.services.items;

  return (
    <section
      className={`bg-white ${compact ? "py-16" : "section-y"}`}
      data-testid="services-section"
    >
      <div className="container-x">
        {!compact && (
          <Reveal className="max-w-3xl mb-16">
            <p className="overline">{t.services.eyebrow}</p>
            <h2 className="mt-4 font-heading font-bold text-brand-ink text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              {t.services.title}
            </h2>
            <p className="mt-6 text-lg text-brand-muted leading-relaxed">
              {t.services.subtitle}
            </p>
          </Reveal>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-brand-border border border-brand-border">
          {items.map((s, i) => (
            <Reveal key={i} delay={i * 90}>
              <Link
                to="/contact"
                className="group bg-white p-8 sm:p-10 flex flex-col gap-5 transition-all duration-500 hover:bg-brand-surface relative h-full"
                data-testid={`service-card-${i}`}
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs tracking-[0.2em] text-brand-deep transition-transform duration-500 group-hover:translate-x-1">{s.tag}</span>
                  <ArrowUpRight
                    size={20}
                    className="text-brand-ink/30 transition-all duration-500 group-hover:text-brand-deep group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:rotate-12"
                  />
                </div>
                <h3 className="font-heading text-2xl sm:text-3xl font-bold text-brand-ink tracking-tight leading-tight transition-colors duration-300 group-hover:text-brand-deep">
                  {s.title}
                </h3>
                <p className="text-brand-muted leading-relaxed">{s.desc}</p>
                <ul className="mt-2 flex flex-wrap gap-2">
                  {s.points.map((p, k) => (
                    <li
                      key={k}
                      className="text-xs font-medium tracking-wide uppercase px-2.5 py-1 border border-brand-border text-brand-ink/70 transition-all duration-300 group-hover:border-brand-deep/40 group-hover:text-brand-deep"
                    >
                      {p}
                    </li>
                  ))}
                </ul>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
